import { createAsyncThunk } from '@reduxjs/toolkit'
import ACTIONS from '../../constants'
import { userAPI } from '../../../shared/api/UserAPI'
import { AppState } from '../../store'
import { Profile } from '../../../shared/model/models'

const { USER } = ACTIONS

export const updateProfile = createAsyncThunk<any, { profile: Profile }, { state: AppState }>(
  USER.UPDATE_PROFILE,
  async ({ profile }, { getState }) => {
    const {
      currentUser: { token, account },
    } = getState()
    if (token && account) {
      await userAPI.updateProfile(account.email, profile)
      return profile
    }
    return []
  },
)
